import "Enum.js";

/** @namespace GIS */
NS("GIS");

/**
 * @extends Enum
 * @enum {number}
 */
GIS.Format = Static(Enum, /** @lends GIS.Format */ {
    GlonassJSON: 1,
    GeoJSON: 2,
    GML2: 3,
    GML3: 4,
    CSV: 5,
    PNG: 6,
    PNG8: 7,
    JPEG: 8,
    GIF: 9,
    HTML: 10,
    /**
     * @param {number} value
     * @returns {string|undefined}
     */
    mimeType: function(value) {
        switch (_.parseInt(value)) {
            case this.GlonassJSON:
            case this.GeoJSON:
                return "application/json";
            case this.GML2:
                return "application/vnd.ogc.gml";
            case this.GML3:
                return "application/vnd.ogc.gml/3.1.1";
            case this.CSV:
                return "text/csv";
            case this.PNG:
                return "image/png";
            case this.PNG8:
                return "image/png8";
            case this.JPEG:
                return "image/jpeg";
            case this.GIF:
                return "image/gif";
            case this.HTML:
                return "text/html";
        }
    },
    /**
     * Returns format name for Web services.
     * @param {number} value
     * @returns {string}
     */
    format: function(value) {
        switch (_.parseInt(value)) {
            case this.GML2:
                return 'gml2';
            case this.GML3:
                return 'gml3';
            default:
                return this.mimeType(value);
        }
    },
    /**
     * @param {number} value
     * @returns {string|undefined}
     */
    extension: function(value) {
        switch (_.parseInt(value)) {
            case this.GlonassJSON:
                return "json";
            case this.GeoJSON:
                return "geojson";
            case this.GML2:
            case this.GML3:
                return "xml";
            case this.CSV:
                return "txt";
            case this.PNG:
            case this.PNG8:
                return "png";
            case this.JPEG:
                return "jpg";
            case this.GIF:
                return "gif";
            case this.HTML:
                return "html";
        }
    },
    /**
     * @param {number} value
     * @returns {string}
     */
    dataType: function(value) {
        switch (_.parseInt(value)) {
            case this.GeoJSON:
            case this.GlonassJSON:
                return 'json';
            case this.GML2:
            case this.GML3:
                return 'xml';
            case this.HTML:
                return 'text';
            default:
                return 'text';
        }
    }
});
